import { Injectable, Inject } from '@angular/core';
import { Szma301aRequest, Szma301aResponse, SZMA301AService } from 'sg-api';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { SgkbConstains } from '../sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSzma301aService {
  /** 契約情報検索（ガス）結果のSubject */
  private _contractGasResult$: Subject<Szma301aResponse> = new Subject<Szma301aResponse>();

  constructor(private sZMA301AService: SZMA301AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  get contractorValueChanges() {
    return this._contractGasResult$.asObservable();
  }
  /**
 *　契約情報検索API呼び出し
 *
 * @param {*} value
 * @memberof UsedSzma301aService
 */
  searchContractor(srvCtrNo: string): Observable<Szma301aResponse> {
    const request: Szma301aRequest = {
      ctrSearchInfo: { srvCtrNo },
    };
    return this.sZMA301AService.c13RSZMA301APost(<Szma301aRequest>this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(response => {
          this.apiCommonService.checkError(response);
          this._contractGasResult$.next(this.setResponseInitialData(response.body));
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SZMA301A);
          return throwError(err.message);
        }));
  }

  /**
   * レスポンスに対し、Szma301aResponseの初期表示値を作成
   *
   * @return {*}  {Szma301aResponse}
   * @memberof UsedSzma301aService
   */
  setResponseInitialData(response: Szma301aResponse): Szma301aResponse {

    let gasCtrSearchResultDto = response.gasCtrSearchResultDto

    if (!gasCtrSearchResultDto.ctrCommonMstInfo || (Object.keys(gasCtrSearchResultDto.ctrCommonMstInfo).length == 0)) {
      gasCtrSearchResultDto.ctrCommonMstInfo = {
        ctrNo: "",
        updateSrno: "",
        srvCtrNo: "",
        prdCode: "",
        prdCtrDate: "",
        prdBreakDate: "",
        firstSrvctrNo: "",
        ctrStateDiv: "",
        ctrStateDivAname: "",
        salfrmCode: "",
        salfrmCodeAname: "",
        rlyisdVisitNo: "",
        rlystrFname: "",
        portalId: "",
        certCode: "",
        payTmprryPw: "",
        agnissVisitNo: "",
        claimMnttmDiv: "",
        claimMnttmDivAname: "",
        ctrefctkiStrtdate: "",
        srvctrInfoMemo: "",
        ctrSyuseiDate: "",
        srvctrBreakRsncod: "",
        srvctrBreakRsncodAname: "",
        autksnCtrfrmDiv: "",
        autksnCtrfrmDivAname: "",
        regTrnDate: "",
        ctrcanTrnDate: "",
        ctrEfctedDate: "",
        claimUnit: "",
        claimUnitAname: "",
        rcvmnySiteiMonth: "",
        rcvmnySiteiMonthAname: "",
        ctrnumBrcno: "",
        ctrupdDiv: "",
        ctrupdDivAname: "",
        ctrStrtdt: "",
        ctrEnddt: "",
        prdAname: "",
        prdRyaku: "",
        prdDispAname: "",
        businsCode: "",
        businsCodeAname: "",
        prdClsfyDiv: "",
        prdClsfyDivAname: "",
        srvClsfyCode: "",
        srvClsfyCodeAname: ""
      }
    }
    if (!gasCtrSearchResultDto.ftiGoodsMstInfo || (Object.keys(gasCtrSearchResultDto.ftiGoodsMstInfo).length == 0 || !gasCtrSearchResultDto.ftiGoodsMstInfo.ftiGoodsMstList)) {
      gasCtrSearchResultDto.ftiGoodsMstInfo = { ftiGoodsMstList: [] };
    }
    if (!gasCtrSearchResultDto.ctrTankaMstInfo || (Object.keys(gasCtrSearchResultDto.ctrTankaMstInfo).length == 0 || !gasCtrSearchResultDto.ctrTankaMstInfo.ctrTankaMstList)) {
      gasCtrSearchResultDto.ctrTankaMstInfo = { ctrTankaMstList: [] };
    }
    if (!gasCtrSearchResultDto.empposUserMstInfo || (Object.keys(gasCtrSearchResultDto.empposUserMstInfo).length == 0 || !gasCtrSearchResultDto.empposUserMstInfo.empposUserMstList)) {
      gasCtrSearchResultDto.empposUserMstInfo = {
        empposUserMstList: [
          {
            empposMstInfo: {
              logicDeviceNo: "",
              srvClsfyCode: "",
              srvClsfyCodeAname: "",
              extCnnctNo: "",
              addrcd: "",
              postno: "",
              pfcAname: "",
              pfcKanaAname: "",
              mptAname: "",
              mptKanaAname: "",
              twareaAname: "",
              twareaKanaAname: "",
              oazaAname: "",
              oazaKanaAname: "",
              banti: "",
              gou: "",
              bunptGou: "",
              supadrAname: "",
              supadrKananm: "",
              yagouAname: "",
              yagouKananm: ""
            },
            userMstInfo: {
              visitNo: "",
              visitKanaName: "",
              visitName: "",
              visitDiv: "",
              visitDivAname: "",
              telNoDiv1: "",
              telNoDiv1Aname: "",
              telNo1: "",
              telNoDiv2: "",
              telNoDiv2Aname: "",
              telNo2: "",
              telNoDiv3: "",
              telNoDiv3Aname: "",
              telNo3: "",
              maddr1: "",
              faxNo1: "",
              addrcd: "",
              postno: "",
              pfcAname: "",
              pfcKanaAname: "",
              mptAname: "",
              mptKanaAname: "",
              twareaAname: "",
              twareaKanaAname: "",
              oazaAname: "",
              oazaKanaAname: "",
              banti: "",
              gou: "",
              bunptGou: "",
              supadrAname: "",
              supadrKananm: "",
              yagouAname: "",
              yagouKananm: ""
            }
          }
        ]
      };
    }

    gasCtrSearchResultDto.empposUserMstInfo.empposUserMstList.forEach((empposUserMstList) => {

      if (!empposUserMstList.empposMstInfo || (Object.keys(empposUserMstList.empposMstInfo).length == 0)) {
        empposUserMstList.empposMstInfo = {
          logicDeviceNo: "",
          srvClsfyCode: "",
          srvClsfyCodeAname: "",
          extCnnctNo: "",
          addrcd: "",
          postno: "",
          pfcAname: "",
          pfcKanaAname: "",
          mptAname: "",
          mptKanaAname: "",
          twareaAname: "",
          twareaKanaAname: "",
          oazaAname: "",
          oazaKanaAname: "",
          banti: "",
          gou: "",
          bunptGou: "",
          supadrAname: "",
          supadrKananm: "",
          yagouAname: "",
          yagouKananm: ""
        }
      }

      if (!empposUserMstList.userMstInfo || (Object.keys(empposUserMstList.userMstInfo).length == 0)) {
        empposUserMstList.userMstInfo = {
          visitNo: "",
          visitKanaName: "",
          visitName: "",
          visitDiv: "",
          visitDivAname: "",
          telNoDiv1: "",
          telNoDiv1Aname: "",
          telNo1: "",
          telNoDiv2: "",
          telNoDiv2Aname: "",
          telNo2: "",
          telNoDiv3: "",
          telNoDiv3Aname: "",
          telNo3: "",
          maddr1: "",
          faxNo1: "",
          addrcd: "",
          postno: "",
          pfcAname: "",
          pfcKanaAname: "",
          mptAname: "",
          mptKanaAname: "",
          twareaAname: "",
          twareaKanaAname: "",
          oazaAname: "",
          oazaKanaAname: "",
          banti: "",
          gou: "",
          bunptGou: "",
          supadrAname: "",
          supadrKananm: "",
          yagouAname: "",
          yagouKananm: ""
        }
      }
    });

    return response;
  }
}
